import { Messages } from '../../../../codegen/Localize';
import { IDataAlertInfo } from '../../../../ts/models/IDataAlertInfo';
import { dataAlertAddMe } from '../../../actions/spaces/DataAlertMenuActions';
import { EntityActionNames, IEntityAction } from './IEntityAction';
import { userIsSubscribedToAnyAlerts } from './IEntityActionHelpers';

export const DataAlertAddMeAction: IEntityAction<IDataAlertInfo, {}> = {
  name: EntityActionNames.AddSelf,
  translateName: Messages.addSelfToAlert_action,
  isVisible: (targetItems: IDataAlertInfo[]) => {
    return targetItems.length > 0;
  },
  isClickable: (_availableActions: {}, targetItems: IDataAlertInfo[]) => {
    // only allow clicking is user isn't subscribed to any results
    return !userIsSubscribedToAnyAlerts(targetItems);
  },
  createReduxAction: (targetItems: IDataAlertInfo[]) => dataAlertAddMe(targetItems)
};
